export * from './tenant.controller'
